/**
 * RISKS-RPS.ROUTE
 * Onglet "Risques psychosociaux" (/risks/rps) : matrice des fonctions et des axes RPS.
 */
import PageHeader from "@/components/page-header"
import RpsRisksMatrix from "@/entities/population/ui/RpsRisksMatrix"
import NavEstablishment from "@/nav/nav.establishment"

export default function RisksRpsRoute() {
  return (
    <NavEstablishment>
      <div className="flex fixed top-[48px] left-0 h-[calc(100%-48px)] app-content-width">
        <div className="py-[20px] px-[20px] lg:px-[40px] flex-1 min-w-0 flex flex-col overflow-auto">
          <PageHeader
            section="Risques"
            title="Risques psychosociaux"
            subtitle="Identifiez les RPS et les mesures de prévention pour chaque fonction."
          />
          <RpsRisksMatrix />
        </div>
      </div>
    </NavEstablishment>
  )
}
